export const INCOMING = 'INCOMING'
export const OUTGOING = 'OUTGOING'
